import React, { useState } from "react"

import style from "./index.module.scss"

import very_card from "../../images/very_card.png"

const very = [
  `До 200 000 грн кредитного ліміту `,
  `Пільговий період до 62 днів`,
  `До 3% кешбеку`,
  `Керування в додатку TAS2U`,
]

const Order = () => {
  const list = very
  const link = "https://tascombank.ua/you/cards/very_card"

  return (
    <div className={style.order}>
      <h2 className={style.title}>Замовлення карток</h2>
      <div className={style.card}>
        <img src={very_card} alt="Замовити картку Таскомбанк" />
        <div className={style.list}>
          <ul style={{ paddingLeft: "10%" }}>
            {list.map((el, i) => (
              <li style={{ marginTop: "4%" }} key={i}>
                {el}
              </li>
            ))}
          </ul>
          <label className={style.gradient_text}>
            <a href={link} name="send_button">
              Замовити картку
            </a>
          </label>
        </div>
      </div>
    </div>
  )
}

export default Order
